import { render } from "./EndingForm.vue?vue&type=template&id=65422290"
import script from "./EndingForm.vue?vue&type=script&lang=js"
export * from "./EndingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__